const ignore = () => {
};
function RaycastOccluder({
  children,
  enabled = true
}) {
  const handler = enabled ? ignore : void 0;
  return <group onPointerOver={handler} onPointerOut={handler} onPointerDown={handler}>
      {children}
    </group>;
}
export {
  RaycastOccluder
};
